import { BaseComponent } from './../base/base.component';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-survey-management-quick-actions',
  template: require('./survey-management-quick-actions.component.html')
})
export class SurveyManagementQuickActionsComponent extends BaseComponent implements OnInit {

  @Input() surveyId: number = -1;

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/survey-management-quick-actions/survey-management-quick-actions.component.ts